import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  /* make full height */\n  display: flex;\n\n  /* prevent the global navigation being crushed while resizing */\n  flex-shrink: 0;\n'], ['\n  /* make full height */\n  display: flex;\n\n  /* prevent the global navigation being crushed while resizing */\n  flex-shrink: 0;\n']);

import styled from 'styled-components';

export default styled.div(_templateObject);